import type { ReactNode } from "react";

export function Spinner({ label = "Loading" }: { label?: string }) {
  return (
    <div role="status" className="flex items-center justify-center gap-3 py-16">
      <span
        aria-hidden="true"
        className="h-5 w-5 animate-spin rounded-full border-2 border-ink-600 border-t-lamp-400"
      />
      <span className="text-sm text-paper-400">{label}…</span>
    </div>
  );
}

export function ErrorState({
  title = "Something went wrong",
  message,
  onRetry,
}: {
  title?: string;
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div
      role="alert"
      className="rounded-sm border border-ink-700 bg-ink-850 px-5 py-8 text-center"
    >
      <h2 className="font-display text-xl text-paper-50">{title}</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-paper-400">{message}</p>

      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-5 rounded-sm border border-ink-600 px-4 py-2 text-sm text-paper-200 hover:border-lamp-400 hover:text-lamp-400"
        >
          Try again
        </button>
      )}
    </div>
  );
}

export function EmptyState({
  title,
  message,
  action,
}: {
  title: string;
  message: string;
  action?: ReactNode;
}) {
  return (
    <div className="rounded-sm border border-dashed border-ink-600 px-5 py-14 text-center">
      <h2 className="font-display text-xl text-paper-50">{title}</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-paper-400">{message}</p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
